import { Card, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CustomTooltip from "./CustomTooltip";

interface CoachStatisticsTableProps {
    data: any;
}

const CoachStatisticsTable = ({ data }: CoachStatisticsTableProps) => {
    const { t } = useTranslation();

    if (!data) return null;

    const tableData = [
        {
            description: t("dashboard.totalCoaches"),
            value: data.totalCoaches || "0",
            tooltip: t("dashboard.tooltips.totalCoaches")
        },
        {
            description: t("dashboard.newCoachesMonth"),
            value: data.totalSignedCoachesInLast30Days || "0",
            tooltip: t("dashboard.tooltips.newCoachesMonth")
        },
        {
            description: t("dashboard.activeCoaches"),
            value: data.totalActiveCoaches || "0",
            tooltip: t("dashboard.tooltips.activeCoaches")
        },
        {
            description: t("dashboard.partiallyActiveCoaches"),
            value: data.totalPartiallyActiveCoaches || "0",
            tooltip: t("dashboard.tooltips.partiallyActiveCoaches")
        },
        {
            description: t("dashboard.inactiveCoaches"),
            value: data.totalInactiveCoaches || "0",
            tooltip: t("dashboard.tooltips.inactiveCoaches")
        }
    ];

    return (
        <Col md={6} className="my-3">
            <Card className="table-card h-100">
                <Card.Header>
                    <h5>{t("dashboard.coachStatistics")}</h5>
                </Card.Header>
                <Card.Body className="py-3 px-0">
                    <div className="table-responsive">
                        <table className="table table-hover table-borderless mb-0">
                            <tbody>
                                {tableData.map((item, key) => (
                                    <tr key={key}>
                                        <td>
                                            <CustomTooltip text={item.tooltip}>
                                                <span className="text-muted">{item.description}</span>
                                            </CustomTooltip>
                                        </td>
                                        <td className="text-end f-w-600">{item.value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default CoachStatisticsTable;
